import { useState } from "react";
import { File } from "lucide-react"

type DCAssetPreviewProps = {
    title: string;
    url: string;
}

<File />
export const DCAssetPreview = ({ title, url }: DCAssetPreviewProps) => {
    return (
        <div 
            className="dc-asset-preview"
            style={{ cursor: "pointer", alignItems: "center", display: "flex" }}
            onClick={() => window.open(url, "_blank")}
        >
            <File size={16} /> &nbsp;{title}
        </div>
    )
}